const prefix = 'tenant-forms'

export const TenantFormsQueryKeys = {
  AvailableForms: `${prefix}/available-forms`,
  TenantForms: `${prefix}/tenant-forms`,
  TenantSncForm: `${prefix}/tenant-snc-form`,
}
